//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DiagrammingLibraryAuthor.js";
import "../no/TaggedObject.js";
import "../no/ugmath.js";
let d=[[[0,"NozzleBottom",1,0],[0,"NozzleLeft",1,0],[0,"NozzleRight",1,0],[0,"NozzleTop",1,0]],[[["num_objects","portObjects"],"GetPortObjects",{},0,0],[["portObject"],"GetPointLocation",{R_:{portLocation:''}},1,0],[["portObject","portLocation"],"SetPointLocation",{},2,0],[["portObject"],"GetConnectionDirection",{R_:{connectionDirection:''}},1,0],[["portObject","connectionDirection"],"SetConnectionDirection",{},2,0],[[],"CreatePort",{R_:{portObject:"DiagrammingLibraryAuthor.AttributeHolder"}},0,0],[["portObject"],"DeletePort",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.DiagrammingLibraryAuthor.PortDataBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DiagrammingLibraryAuthor.PortDataBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;